import React from "react";
import { useLang } from "@/lib/i18n";

/**
 * EN / ES language switcher. Inherits text color from parent via Tailwind.
 */
export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center gap-1.5 eyebrow ${className}`}>
      <button
        type="button"
        onClick={() => setLang("en")}
        className={lang === "en" ? "opacity-100" : "opacity-50 hover:opacity-100"}
        data-testid="lang-en"
      >
        EN
      </button>
      <span aria-hidden className="opacity-40">
        |
      </span>
      <button
        type="button"
        onClick={() => setLang("es")}
        className={lang === "es" ? "opacity-100" : "opacity-50 hover:opacity-100"}
        data-testid="lang-es"
      >
        ES
      </button>
    </div>
  );
}
